module.exports = __webpack_public_path__ + "static/media/lia-e-carlos-macedo.095fc179.jpg";